import { RequestServiceOptions } from '@atlaskit/util-service-support/types';
import { utils } from '@atlaskit/util-service-support';

import { getConfig } from '@townsquare/config';

import {
	AvailableProductsResponse,
	GetAvailableSitesArgs,
	getAvailableProductsResult,
	getAvailableSitesCloudIdsResult,
} from './types';

const UNTENANTED_PRODUCTS = ['TRELLO', 'BITBUCKET'];

export default class AvailableSitesProvider {
	private baseUrl: string;
	private promise?: Promise<AvailableProductsResponse>;

	constructor(baseUrl: string) {
		this.baseUrl = baseUrl;
	}

	/**
	 * Get all the cloudIds of sites the current user has access to
	 * @returns an array of cloudIds
	 */
	async getAvailableSitesCloudIds(siteArgs: GetAvailableSitesArgs): Promise<getAvailableSitesCloudIdsResult> {
		return this.getAvailableProducts(siteArgs).then(resp => ({
			data: resp.data.map(site => site.cloudId),
			error: resp.error,
		}));
	}

	/**
	 * Get all the sites with product info the current user has access to
	 * @returns an array of AvailableSite
	 */
	async getAvailableProducts({
		cloudIdsToFilterFor,
		orgId,
	}: GetAvailableSitesArgs): Promise<getAvailableProductsResult> {
		const defaultResponse: getAvailableProductsResult = { data: [], error: false };

		if (!this.promise) {
			const options: RequestServiceOptions = {
				queryParams: {
					source: 'home-fe',
					orgid: orgId ?? '',
				},
				requestInit: {
					mode: 'cors',
					headers: {
						'Content-Type': 'application/json',
					},
				},
			};

			this.promise = utils.requestService({ url: `${getConfig().appSwitcherBffUrl}/api/available-products` }, options);
		}

		try {
			const response = await this.promise;

			if (!response.sites) {
				return defaultResponse;
			}

			const sites = cloudIdsToFilterFor
				? response.sites.filter(site => cloudIdsToFilterFor.concat(UNTENANTED_PRODUCTS).includes(site.cloudId))
				: response.sites;

			return {
				data: sites,
				error: false,
			};
		} catch (error) {
			console.error('Could not retrieve available sites: ', error);
			return {
				data: [],
				error: true,
			};
		}
	}
}
